import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { IMissionPlanConfig } from './missionPlanConfig/IMissionPlanConfig'


export class IrisrawModMissionPlanConfig extends IrisModContainer<IrisConfigContainer<IMissionPlanConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModMissionPlanConfig.createIrisrawModMissionPlanConfigConfig)        
    }

    static createIrisrawModMissionPlanConfig(datas:IIrisModContainerConstParam) {        
        return new IrisrawModMissionPlanConfig(datas)
    }

    static createIrisrawModMissionPlanConfigConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<IMissionPlanConfig>(data)
    }

}
